import { Col, Modal, Row, Tab, Tabs } from "react-bootstrap";
import { GroupButton } from "../../components/GroupButton";
import { useContext, useEffect, useState } from "react";
import TabTableChamCong from "./TabTableChamCong";
import "../time-sheet.scss"
import TabTableChamCongTruc from "./TabTableChamCongTruc";
import AppContext from "../../../AppContext";
import { searchTimeSheet } from "../services/timesheetServices";
import { RESPONSE_STATUS_CODE } from "../../constants/moduleConsts";
import { toast } from "react-toastify";
import useMultiLanguage from "../../../hook/useMultiLanguage";
import TabTableTinhCongTruc from "./TabTableTinhCongTruc";
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { localStorageItem } from "../../utils/localStorage";

const DialogPrintTimekeeping = (props: any) => {
  const {
    open,
    dateSearch = {},
    listAttribution = [],
    handleClose = () => { }
  } = props;
  const { setPageLoading } = useContext(AppContext);
  const { lang } = useMultiLanguage();

  const LIST_TAB_TIMESHEET_TABLE = [
    { id: "1", nameTab: lang("GENERAL.TIMEKEEPING_TABLE") },
    { id: "2", nameTab: lang("TIMEKEEPING_SHIFT_TABLE") },
    { id: "3", nameTab: lang("PAY_TIMEKEEPING_SHIFT_TABLE") }
  ];

  const employee = localStorageItem.get(KEY_LOCALSTORAGE.EMPLOYEE);

  const [activeTab, setActiveTab] = useState<string>("1");
  const [data, setData] = useState([]);

  useEffect(() => {
    if (activeTab === "1") {
      setData([]);
      handleGetDataChamCongTruc({
        ...dateSearch,
        mauBangCong: 1
      });
    } else if (activeTab === "2" || activeTab === "3") {
      setData([]);
      handleGetDataChamCongTruc({
        ...dateSearch,
        mauBangCong: 2
      })
    }
  }, [activeTab])

  const handleGetDataChamCongTruc = async (dateSearch: any) => {
    try {
      setPageLoading(true);
      const { data } = await searchTimeSheet(dateSearch);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        setData(data?.data?.content || [])
      } else toast.warning(data?.message);
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  const handleTabChange = (key: string | null) => {
    key && setActiveTab(key);
  };

  const handlePrint = () => {
    const style = `
            @media print {
                body { zoom: 0.7; margin: 20px 50px }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid black; text-align: center; }

                table td.isWeekendPrint, table th.isWeekendPrint {
                    background-color: #ffd6b4 !important;
                    -webkit-print-color-adjust: exact;
                    print-color-adjust: exact;
                }

                .container-title {
                    position: relative;
                    padding-top: 1.25rem;
                    margin-bottom: 1.25rem;
                }

                .title-table-print {
                    font-weight: bold;
                    text-transform: uppercase;
                    font-size: 1.75rem;
                    text-align: center;
                    margin: 0px;
                }

                .title-time-print {
                    font-weight: bold;
                    font-size: 1.25rem;
                    text-align: center;
                    margin: 0px;
                }

                .container-header {
                    display: flex;
                    justify-content: space-between;
                    margin-left: 1.25rem;
                    margin-top: 3rem;
                }

                .title-header {
                    font-weight: bold;
                    font-size: 1.35rem;
                    text-align: center;
                    margin: 0px;
                }

                .text-left {
                    text-align: left !important;
                }

                .container-footer {
                    margin-top: 30px;
                    margin-bottom: 100px;
                }

                .time-footer {
                    text-align: end;
                    font-style: italic;
                    margin-bottom: 10px;
                }

                .footer {
                    display: flex;
                    justify-content: space-between;
                }

                .title-footer {
                    text-align: center;
                    font-weight: bold;
                    margin: 0;
                }

                .span-footer {
                    text-align: center;
                    font-style: italic;
                    margin: 0;
                }

                .text-uppercase {
                    text-transform: uppercase;
                }

                @page {
                    margin: 20px !important;
                }
            }
        `;

    const content = document.getElementById("content-print");
    if (content) {
      const printWindow = window.open('', '_blank', 'width=800,height=600');
      if (printWindow) {
        let title = "";
        switch (activeTab) {
          case "1":
            title = `Bang_Cham_Cong_Thang_${dateSearch.thang}_Nam_${dateSearch.nam}`;
            break;
          case "2":
            title = `Bang_Cham_Cong_Truc_Chuyen_Mon_Thang_${dateSearch.thang}_Nam_${dateSearch.nam}`;
            break;
          case "3":
            title = `Bang_Thanh_Toan_Cong_Truc_Thang_${dateSearch.thang}_Nam_${dateSearch.nam}`;
            break;
          default:
            title = "TenMacDinh";
            break;
        }
        printWindow.document.open();
        printWindow.document.write(`
              <html>
                <head>
                  <title>${title}</title>
                  <style>${style}</style>
                </head>
                <body onload="window.print(); window.close();">
                  ${content.innerHTML}
                </body>
              </html>
            `);
        printWindow.document.close();
      }
    }
  };

  if (!open) return <></>

  return (
    <Modal
      show={open}
      onHide={() => {
        handleClose();
      }}
      backdrop="static"
      size="xl"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {lang("PRINT_TIMEKEEPING_TABLE")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="spaces py-0">
        <div className="time-sheets-print">
          <Row>
            <Tabs
              activeKey={activeTab}
              defaultActiveKey={1}
              id="justify-tab-example"
              className="spaces p-0"
              onSelect={handleTabChange}
            >
              {LIST_TAB_TIMESHEET_TABLE.map((tab, index) => (
                <Tab
                  key={`tab-timesheet-${index}`}
                  eventKey={tab.id}
                  title={tab.nameTab}
                  className="tab-content"
                  id={tab.id}
                  mountOnEnter
                >
                </Tab>
              ))}
            </Tabs>
          </Row>
          <Row id="content-print" className="px-4">
            <div className="container-header ms-5 mt-5">
              <div>
                <p className="fw-bold text-uppercase fs-3 text-center m-0 title-header">
                  {(data[0] as any)?.orgName || employee?.donViCongTacText || ""}
                </p>
                <p className="fw-bold text-uppercase fs-3 text-center m-0 title-header">
                  {(data[0] as any)?.phongBanText || employee?.phongBanText || ""}
                </p>
              </div>
              {["1", "2"].includes(activeTab) &&
                <div>
                  <p className="fw-bold text-center m-0 title-header">Mẫu số C01a - HD</p>
                  <p className="fw-bold text-center m-0 title-header">(Ban hành theo thông tư số: 107/2017/TT-BTC</p>
                  <p className="fw-bold text-center m-0 title-header">ngày 10/10/2017 của Bộ Tài chính)</p>
                </div>
              }
            </div>
            {activeTab === "1" &&
              <Col xs={12}>
                <div className="container-title relative pt-5 mb-3">
                  <p className='fw-bold text-uppercase fs-1 text-center m-0 title-table-print'>{lang("GENERAL.TIMEKEEPING_TABLE")}</p>
                  <p className='fw-bold fs-4 text-center m-0 title-time-print'>{`Tháng ${dateSearch.thang ?? "....."} năm ${dateSearch.nam ?? "....."}`}</p>
                </div>
                <TabTableChamCong
                  data={data}
                  dateSearch={dateSearch}
                  listAttribution={listAttribution}
                />
              </Col>
            }
            {activeTab === "2" &&
              <Col xs={12}>
                <div className="container-title relative pt-5 mb-3">
                  <p className='fw-bold text-uppercase fs-1 text-center m-0 title-table-print'>{lang("TIMEKEEPING_SHIFT_TABLE")}</p>
                  <p className='fw-bold fs-4 text-center m-0 title-time-print'>{`Tháng ${dateSearch.thang ?? "....."} năm ${dateSearch.nam ?? "....."}`}</p>
                </div>
                <TabTableChamCongTruc
                  data={data}
                  dateSearch={dateSearch}
                  listAttribution={listAttribution}
                />
              </Col>
            }
            {activeTab === "3" &&
              <Col xs={12}>
                <div className="container-title relative pt-5 mb-3">
                  <p className='fw-bold text-uppercase fs-1 text-center m-0 title-table-print'>{lang("PAY_TIMEKEEPING_SHIFT_TABLE")}</p>
                  <p className='fw-bold fs-4 text-center m-0 title-time-print'>{`Tháng ${dateSearch.thang ?? "....."} năm ${dateSearch.nam ?? "....."}`}</p>
                </div>
                <TabTableTinhCongTruc
                  data={data}
                />
              </Col>
            }

            <div className="container-footer">
              <div className="time-footer">......, Ngày ..... tháng ..... năm ....</div>
              <div className="footer">
                <div>
                  <p className="title-footer">Người chấm công</p>
                  <p className="span-footer">(Ký, Họ tên)</p>
                </div>
                <div>
                  <p className="title-footer">Phụ trách khoa, phòng</p>
                  <p className="span-footer">(Ký, Họ tên)</p>
                </div>
                <div>
                  <p className="title-footer">Người duyệt</p>
                  <p className="span-footer">(Ký, Họ tên)</p>
                </div>
              </div>
            </div>
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <GroupButton
          handleEvent={() => {
            handlePrint();
          }}
        >
          {lang("BTN.PRINT")}
        </GroupButton>
        <GroupButton
          type="btn-cancel"
          handleCloseUpdateDialog={() => {
            handleClose();
          }}
        />
      </Modal.Footer>
    </Modal>
  )
};

export default DialogPrintTimekeeping;